import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="team-members"
export default class extends Controller {
  static targets = ["list", "count"]
  static values = {
    selected: Array
  }

  connect() {
    this.updateCount()
  }

  addMember(event) {
    event.preventDefault()
    const option = event.currentTarget
    const memberId = option.dataset.id
    const memberName = option.dataset.text
    const memberEmail = option.dataset.email

    // Check if already added
    if (this.listTarget.querySelector(`[data-member-id="${memberId}"]`)) {
      // Close the dropdown
      const dropdown = option.closest('[data-searchable-select-target="dropdown"]')
      if (dropdown) dropdown.classList.add('hidden')
      return
    }

    // Get the first letter for avatar
    const firstLetter = (memberName || memberEmail).charAt(0).toUpperCase()

    // Remove empty state if exists
    // (Detect the empty state structurally; its text is translated.)
    if (!this.listTarget.querySelector('[data-member-id]')) {
      this.listTarget.innerHTML = ''
    }

    // Create member element
    const memberDiv = document.createElement('div')
    memberDiv.className = 'flex items-center justify-between p-4 rounded-lg bg-[#0f1b23] border border-[#2f516a] hover:border-primary/50 transition-colors'
    memberDiv.dataset.memberId = memberId
    memberDiv.innerHTML = `
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary font-semibold shrink-0">
          ${firstLetter}
        </div>
        <div>
          <p class="text-white font-medium">${memberName}</p>
          <p class="text-sm text-gray-400">${memberEmail}</p>
        </div>
      </div>
      <button type="button"
              data-action="click->team-members#removeMember"
              data-member-id="${memberId}"
              class="p-2 rounded-lg hover:bg-red-500/20 text-gray-400 hover:text-red-400 transition-colors"
              title="${t('javascript.controllers.team_members_controller.remove_from_team')}">
        <span class="material-symbols-outlined !text-xl">close</span>
      </button>
      <input type="hidden" name="member_ids[]" value="${memberId}">
    `

    this.listTarget.appendChild(memberDiv)
    this.updateCount()

    // Close the dropdown
    const dropdown = option.closest('[data-searchable-select-target="dropdown"]')
    if (dropdown) dropdown.classList.add('hidden')
  }

  removeMember(event) {
    event.preventDefault()
    const button = event.currentTarget
    const memberId = button.dataset.memberId
    const memberDiv = this.listTarget.querySelector(`[data-member-id="${memberId}"]`)

    if (memberDiv) {
      memberDiv.remove()
      this.updateCount()

      // If no members left, show empty state
      if (this.listTarget.children.length === 0) {
        this.showEmptyState()
      }
    }
  }

  updateCount() {
    const count = this.listTarget.querySelectorAll('[data-member-id]').length
    if (this.hasCountTarget) {
      this.countTarget.textContent = count
    }
  }

  showEmptyState() {
    this.listTarget.innerHTML = `
      <div class="p-8 text-center rounded-lg bg-[#0f1b23] border border-[#2f516a]">
        <span class="material-symbols-outlined text-gray-500 !text-5xl mb-3">group_off</span>
        <p class="text-gray-400">${t('javascript.controllers.team_members_controller.no_members_selected_yet')}</p>
        <p class="text-sm text-gray-500 mt-1">${t('javascript.controllers.team_members_controller.use_search_to_add_members')}</p>
      </div>
    `
  }
}

